var _path, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlignLeftc1F38311(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_AlignLeft",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103052",
    "data-name": "Path 103052",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_5387",
    "data-name": "Line 5387",
    x2: 16,
    transform: "translate(4 5)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_5388",
    "data-name": "Line 5388",
    x2: 8,
    transform: "translate(4 10)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_5406",
    "data-name": "Line 5406",
    x2: 8,
    transform: "translate(4 20)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_5389",
    "data-name": "Line 5389",
    x2: 16,
    transform: "translate(4 15)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlignLeftc1F38311);
export default __webpack_public_path__ + "static/media/ic_AlignLeft.c1f38311.89d27079a63098b16a21c6193844c684.svg";
export { ForwardRef as ReactComponent };